import React, { useEffect, useRef, useState } from "react";
import "./autocomplete.css"
import { FaSearch, FaMapMarkerAlt, FaHome, FaChevronDown, FaChevronUp, FaRupeeSign } from "react-icons/fa";
import PropertyTypeDropdown from "./PropertyTypeDropdown";
import useCustomNavigate from "../../../hooks/useCustomNavigate";
import { GoogleKeys } from "../../../config/google";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import { formatNumberUtil } from "../../../Utils/localStorageUtils";
import { banner_bg_image, bg_image, bg_image_2, bg_image_3 } from "../../../Utils/export";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import PropertyTypeDropdown2 from "./PropertyTypeDropdown2";
import LZString from 'lz-string';
import { useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import BudgetSlider from "./BudgetSlider";

const libraries = ["places"]; // Places API ke liye required libraries
const googleMapsApiKey = GoogleKeys.GOOGLE_MAPS_API_KEY // .env me store karna

const priceOptions = {
  "₹5 Lac": 500000,
  "₹10 Lac": 1000000,
  "₹20 Lac": 2000000,
  "₹30 Lac": 3000000,
  "₹40 Lac": 4000000,
  "₹50 Lac": 5000000,
  "₹60 Lac": 6000000,
};



const bannerImages = [
  "https://i.pinimg.com/736x/c1/df/87/c1df875d53d18c0e8cd9ac21a20c035c.jpg",
  // "https://i.pinimg.com/236x/dc/68/ae/dc68ae2ecb327ddb8f68b244894df2f3.jpg",
  // "https://i.pinimg.com/236x/f5/c4/64/f5c464ad4f70ac68c322a16ad0e44e98.jpg",
  bg_image,
  bg_image_2,
  bg_image_3,
];


const PropertySearchBar = () => {

  const { goTo } = useCustomNavigate()
  const currentLocationDetails = useSelector((state) => state?.counter?.location)

  const [isListening, setIsListening] = useState(false);

  const [activeDropdown, setActiveDropdown] = useState(null); // Track the active dropdown
  const dropdownRef = useRef(null);
  const autocompleteRef = useRef(null);

  const inputRef = useRef(null);

  const [formValues, setFormValues] = useState({
    location: "",
    budgetMin: 0,
    budgetMax: "",
    propertyType: [],
    bhkSelection: [],
    commercialSelection: [],
    pgGender: [],
    subSelection: [],
    activeTab: "Buy", // Added to track the active tab
  });


  console.log("formValuesformValues", formValues)
  console.log("currentLocationDetails", currentLocationDetails)

  const [selectedMinBudget, setSelectedMinBudget] = useState("");
  const [selectedMaxBudget, setSelectedMaxBudget] = useState("");
  const [isMaxPriceSelected, setIsMaxPriceSelected] = useState(false); // Track if Max Price is selected
  const [isMinPriceSelected, setIsMinPriceSelected] = useState(true); // Track if Min Price is selected

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null); // Close all dropdowns
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleDropdownSelection = (key, value) => {
    setFormValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleArraySelection = (key, value) => {
    setFormValues((prev) => ({
      ...prev,
      [key]: prev[key].includes(value)
        ? prev[key].filter((item) => item !== value)
        : [...prev[key], value],
    }));
  };


  const handleTabChange = (tab) => {
    setActiveTab(tab); // Update active tab

    setFormValues((prev) => ({
      ...prev, // Keep the previous values for activeTab
      activeTab: tab, // Set the new activeTab
      location: "", // Clear location
      budgetMin: "", // Clear min budget
      budgetMax: "", // Clear max budget
      propertyType: [], // Clear property type
      bhkSelection: [], // Clear bhk selection
      commercialSelection: [], // Clear commercial selection
      pgGender: [],
      subSelection: [],
      areaRange: {}
    }));
  };



  // Handle Min Budget selection
  const handleMinBudgetSelect = (value) => {
    const formattedValue = priceOptions[value] || "";
    setSelectedMinBudget(value);
    setFormValues((prev) => ({
      ...prev,
      budgetMin: formattedValue,
    }));
    setIsMinPriceSelected(false); // Enable Max Price selection after Min is selected
    setIsMaxPriceSelected(true); // Reset Max Price selection state
  };

  // Handle Max Budget selection
  const handleMaxBudgetSelect = (value) => {
    const formattedValue = priceOptions[value] || "";
    setSelectedMaxBudget(value);
    setFormValues((prev) => ({
      ...prev,
      budgetMax: formattedValue,
    }));
    setActiveDropdown(null);
  };



  // Speech-to-Text function for voice input
  const handleVoiceInput = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      alert("Your browser does not support Speech Recognition.");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "en-US"; // Change to "hi-IN" for Hindi
    recognition.continuous = false;
    recognition.interimResults = false;

    recognition.onstart = () => {
      setIsListening(true);
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setFormValues((prev) => ({
        ...prev,
        location: transcript,
      }));

      // ✅ Focus input field and open autocomplete dropdown
      if (inputRef.current) {
        setTimeout(() => {
          inputRef.current.focus(); // 🔥 Focus Input
          inputRef.current.dispatchEvent(new KeyboardEvent("keydown", { key: "ArrowDown" })); // 🔥 Open Dropdown
        }, 500);
      }
    };


    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.onerror = (event) => {
      console.error("Speech Recognition Error:", event.error);
      setIsListening(false);
    };

    recognition.start();
  };






  const handlePlaceSelect = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      if (place && place.formatted_address && place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        setFormValues((prev) => ({
          ...prev,
          location: place.formatted_address,
          latitude: lat,   // Latitude store
          longitude: lng,   // Longitude store
        }));

        console.log("Selected Location:", place.formatted_address);
        console.log("Latitude:", lat);
        console.log("Longitude:", lng);
      }
    }
  };



  const tabs = [
    "Buy",
    "Rent",
    "New Projects",
    "PG",
    "Plot",
    "Commercial",
  ];

  const [activeTab, setActiveTab] = useState("Buy"); // Default active tab




  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    console.log("Form submitted with values:", formValues);
  };

  // Handle Search button click
  const handleSearchClick = () => {
    try {

      // Add currentLocationDetails to formValues
      const updatedFormValues = {
        ...formValues,
        userSelectedLocationDetails: currentLocationDetails,  // Adding currentLocationDetails here
      };

      console.log("updatedFormValues", updatedFormValues)


      // Encode formValues in Base64 format
      const encodedData = btoa(JSON.stringify(updatedFormValues));

      // Open new tab with encoded data in query
      window.open(`/searchresult/${encodedData}`, "_blank");

    } catch (error) {
      console.error("Error during search: ", error);
    }
  };


  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isSliderActive, setIsSliderActive] = useState(false);

  useEffect(() => {
    // Delay slider activation by 3 seconds (adjust as needed)
    const timer = setTimeout(() => {
      setIsSliderActive(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isSliderActive) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % bannerImages.length);
    }, 4000); // Slide change interval

    return () => clearInterval(interval);
  }, [isSliderActive]); // Start sliding only after isSliderActive is true

  const handleSliderChange = (newValue) => {
    setFormValues((prev)=>({
      ...prev,
      budgetMin:  formValues.budgetMin || 0,
      budgetMax: newValue[1],
    }));
  };


  return (
    <LoadScript googleMapsApiKey={googleMapsApiKey} libraries={libraries}>
      <div className="relative h-[500px] w-full overflow-hidden" style={{ scrollbarWidth: "none" }}>
        <AnimatePresence>
          <motion.div
            key={currentImageIndex}
            initial={isSliderActive ? { x: "100%" } : { x: "0%" }} // No animation initially
            animate={{ x: "0%" }}
            exit={{ x: "-100%" }}
            transition={{ duration: 1 }}
            className="absolute inset-0 h-full w-full bg-center bg-no-repeat bg-cover"
            style={{ backgroundImage: `url(${bannerImages[currentImageIndex]})` }}
          />
        </AnimatePresence>

        <div className="absolute inset-0 bg-black/40 rounded-lg  transition-opacity duration-700 opacity-100  z-0" />

        <div className="absolute inset-0 flex flex-col justify-center items-center px-8 top-20">
          {/* Heading */}
          <h1 className="text-center text-2xl font-semibold text-white mb-6">
            Welcome back! Let’s continue your search
          </h1>

          {/* Navigation Tabs */}
          <div className="flex justify-center gap-8 mb-6 relative">
            {tabs.map(
              (tab, index) => (
                <button
                  type="button"
                  key={index}
                  onClick={() => handleTabChange(tab)} // Use the new handleTabChange function
                  className={`text-white text-[16px] font-medium px-2 py-1  ${activeTab === tab ? "text-white text-[16px]  px-3   border-b-2 border-[#2b463c] bg-[#2b463c] rounded-[10px]" : "hover:text-white"
                    }`}
                >
                  {tab}
                </button>
              )
            )}
          </div>
          <form onSubmit={handleSubmit}>
            {/* Search Bar */}
            <div className="flex w-full justify-center" ref={dropdownRef}>
              <div className="relative flex items-center  gap-4 bg-white px-3 rounded-full border border-black py-2 w-[900px]">
                {/* Location */}
                <div className="relative flex   items-center gap-2 w-[40%]">
                  <div className="p-2 bg-red-50 rounded-full w-[10%]">
                    <FaMapMarkerAlt className="text-gray-500 w-5 h-5" />
                  </div>
                  <Autocomplete
                    onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
                    onPlaceChanged={handlePlaceSelect}
                    options={{
                      // types: ["(cities)"], // Sirf cities ke suggestions
                      componentRestrictions: { country: "IN" }, // India specific

                    }}
                    className="w-full"
                  >
                    <input
                      ref={inputRef} // ✅ Reference for opening dropdown
                      name="location"
                      type="text"
                      placeholder="Search location..."
                      value={formValues.location}
                      onChange={handleInputChange}
                      className="border-none outline-none bg-transparent text-gray-700 w-full"
                    />
                  </Autocomplete>

                  <button
                    onClick={handleVoiceInput} type="button"
                    className="ml-2 w-[10%]"

                  >
                    {isListening ? (
                      <FaMicrophoneSlash className="text-red-500 text-xl" />
                    ) : (
                      <FaMicrophone className="text-blue-500 text-xl" />
                    )}
                  </button>

                </div>

                {/* Divider */}
                <div className="h-6 w-[1px] bg-gray-300"></div>

                {/* Property Type */}
                <div className="w-[20%]">
                  {/* <PropertyTypeDropdown

                  formValues={formValues}
                  setFormValues={setFormValues}
                  activeDropdown={activeDropdown}
                  setActiveDropdown={setActiveDropdown}
                /> */}
                  <PropertyTypeDropdown2

                    formValues={formValues}
                    setFormValues={setFormValues}
                    activeDropdown={activeDropdown}
                    setActiveDropdown={setActiveDropdown}
                  />
                </div>

                {/* Divider */}
                <div className="h-6 w-[1px] bg-gray-300"></div>

                {/* Budget */}
                <div className="relative w-[20%]">
                  <div
                    className="flex items-center gap-2 cursor-pointer"
                    onClick={() => {
                      setActiveDropdown(activeDropdown === "budget" ? null : "budget");
                      setIsMinPriceSelected(true)
                      setIsMaxPriceSelected(false)
                    }

                    }
                  >
                    <FaRupeeSign className="text-gray-500 w-5 h-5" />
                    <span className="text-gray-700 truncate">
                      {formValues.budgetMax
                        ? `${formatNumberUtil(formValues.budgetMin)} - ${formatNumberUtil(formValues.budgetMax)}`
                        : "Budget"}
                    </span>
                    <FaChevronDown
                      className={`text-gray-500 w-4 h-4 transition-transform duration-300  ${activeDropdown === "budget" ? "-rotate-180" : "rotate-0"
                        }`}
                    />
                  </div>

                  {/* Dropdown */}
                  {activeDropdown === "budget" && (
                    <div className="absolute top-full mt-2 w-[250px] bg-white p-4 rounded-lg shadow-lg border border-gray-300 z-10">
                      <div className="flex gap-2 mb-4">

                        <BudgetSlider 
                        min={0}
                        max={10000000}
                        step={100000}
                        value={[formValues.budgetMin, formValues.budgetMax]} // Pass current min/max
                        onChange={handleSliderChange} // Pass the handler to update the parent
                        />
                      </div>

                    </div>
                  )}
                </div>

                {/* Search Button */}
                <button
                  type="submit"
                  className="bg-[#2b463c] w-[20%] text-white px-6 py-2 rounded-full flex items-center gap-2 "
                  onClick={handleSearchClick}
                >
                  <FaSearch className="w-5 h-5" />
                  Search
                </button>
              </div>
            </div>
          </form>
        </div>
        {/* Dots Indicator */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
          {bannerImages.map((_, index) => (
            <div
              key={index}
              className={`w-3 h-3 rounded-full ${currentImageIndex === index ? "bg-white" : "bg-gray-900"}`}
            />
          ))}
        </div>
      </div>
    </LoadScript>
  );
};

export default PropertySearchBar;
